/**
* NGTDialogPlayerEvent.js
* 
* Created on Oct 3, 2013, 2:49:07 PM
*
* @author Javier Quevedo-Fernandez for Ranj
**/
export default class NGTDialogPlayerEvent {
    constructor(type, data, option) {
        this.type = type;
        this.data = data;
        this.option = option;
    }
}

NGTDialogPlayerEvent.DIALOG_CONTENT = "DIALOG_CONTENT";
NGTDialogPlayerEvent.DIALOG_OPTION = "DIALOG_OPTION";
NGTDialogPlayerEvent.DIALOG_OPTIONS_CHANGED = "DIALOG_OPTIONS_CHANGED";
NGTDialogPlayerEvent.DIALOG_OPTION_CHOSEN = "DIALOG_OPTION_CHOSEN";
NGTDialogPlayerEvent.DIALOG_COMMAND = "DIALOG_COMMAND";
NGTDialogPlayerEvent.DIALOG_END = "DIALOG_END";
NGTDialogPlayerEvent.DIALOG_TIMER = "DIALOG_TIMER";
NGTDialogPlayerEvent.DIALOG_TIME_OUT = "DIALOG_TIME_OUT";
NGTDialogPlayerEvent.ANSWER_TIMER = "ANSWER_TIMER";
NGTDialogPlayerEvent.COMMAND_SEQUENCE_END = "COMMAND_SEQUENCE_END";